import React, { useState, useEffect } from 'react'
import ToastComponent from 'src/components/common/TaostComponent'
import {
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CRow,
  CAccordion,
  CAccordionItem,
  CAccordionHeader,
  CAccordionBody,
} from '@coreui/react-pro'
import CommonService from 'src/service/CommonService'
import MemberCodeListing from './MemberCodeListing'
import AddMemberCode from './AddMemberCode'
import ImportMemberJoinCode from './ImportMemberJoinCode'

// section: 'all' (default, standalone page with collapsible accordions),
// 'import' (Import Game Guests only) or 'createList' (Create + List, always expanded).
const MemberCode = ({ section = 'all' }) => {
  const showImport = section === 'all' || section === 'import'
  const showCreateList = section === 'all' || section === 'createList'
  const [openImport, setOpenImport] = useState(false)
  const [openCreate, setOpenCreate] = useState(false)
  const [openList, setOpenList] = useState(1)
  const [loading, setLoading] = useState()
  const [activePage, setActivePage] = useState(1)
  const [columnFilter, setColumnFilter] = useState([])
  const [columnSorter, setColumnSorter] = useState(null)
  const [itemsPerPage, setItemsPerPage] = useState(10)
  const [users, setUsers] = useState({})
  const columns = [
    { label: 'Code', filter: true, sorter: true, key: 'invite_code' },
    { label: 'First Name', filter: true, sorter: true, key: 'first_name' },
    { label: 'Last Name', filter: true, sorter: true, key: 'last_name' },
    { label: 'Email', filter: true, sorter: true, key: 'email' },
    { label: 'Created On', filter: false, sorter: true, key: 'created_at' },
    { label: 'Sent', filter: false, sorter: true, key: 'is_sent' },
    {
      key: 'actions',
      label: 'Code',
      filter: false,
      sorter: false,
    },
  ]

  useEffect(() => {
    fetchData(activePage, columnFilter, columnSorter, itemsPerPage)
  }, [activePage, columnFilter, columnSorter, itemsPerPage])

  const fetchData = (
    pageParam = activePage,
    filterParam = columnFilter,
    sorterParam = columnSorter,
    perPageParam = itemsPerPage,
  ) => {
    const offset = perPageParam * pageParam - perPageParam
    let params = new URLSearchParams()
    Object.keys(filterParam || {}).forEach((key) => {
      params.append(key, filterParam[key])
    })
    sorterParam &&
      sorterParam.column !== undefined &&
      params.append('sort', `${sorterParam.column}%${sorterParam.state}`)

    CommonService.getJoinCodeMember(offset, perPageParam, pageParam, params).then((result) => {
      setUsers(result.data)
      setLoading(false)
    })
  }

  if (section !== 'all') {
    return (
      <CRow className="g-3">
        <CCol xs={12}>
          {showImport && <ImportMemberJoinCode fetchData={fetchData} />}
          {showCreateList && (
            <>
              <CCard className="mb-4">
                <CCardHeader>
                  <strong>Create Game Guest</strong>
                </CCardHeader>
                <CCardBody>
                  <AddMemberCode
                    activePage={activePage}
                    columnFilter={columnFilter}
                    columnSorter={columnSorter}
                    itemsPerPage={itemsPerPage}
                    fetchData={fetchData}
                  />
                </CCardBody>
              </CCard>
              <CCard>
                <CCardHeader>
                  <strong>Game Guests List</strong>
                </CCardHeader>
                <CCardBody>
                  <MemberCodeListing
                    users={users}
                    columns={columns}
                    itemsPerPage={itemsPerPage}
                    loading={loading}
                    activePage={activePage}
                    columnFilter={columnFilter}
                    columnSorter={columnSorter}
                    setActivePage={setActivePage}
                    setItemsPerPage={setItemsPerPage}
                    setColumnSorter={setColumnSorter}
                    setColumnFilter={setColumnFilter}
                    fetchData={fetchData}
                    setLoading={setLoading}
                  />
                </CCardBody>
              </CCard>
            </>
          )}
        </CCol>
      </CRow>
    )
  }

  return (
    <CRow className="g-3">
      <CAccordion
        activeItemKey={openImport ? 1 : 0}
        onActiveItemKeyChange={(k) => setOpenImport(!!k)}
      >
        <CAccordionItem itemKey={1}>
          <CAccordionHeader>
            <strong>Import Game Guests</strong>
          </CAccordionHeader>
          <CAccordionBody>
            <ImportMemberJoinCode fetchData={fetchData} />
          </CAccordionBody>
        </CAccordionItem>
      </CAccordion>
      <CAccordion
        activeItemKey={openCreate ? 1 : 0}
        onActiveItemKeyChange={(k) => setOpenCreate(!!k)}
      >
        <CAccordionItem itemKey={1}>
          <CAccordionHeader>
            <strong>Create Game Guests</strong>
          </CAccordionHeader>
          <CAccordionBody>
            <AddMemberCode
              activePage={activePage}
              columnFilter={columnFilter}
              columnSorter={columnSorter}
              itemsPerPage={itemsPerPage}
              fetchData={fetchData}
            />
          </CAccordionBody>
        </CAccordionItem>
      </CAccordion>
      <CAccordion activeItemKey={openList ? 1 : 0} onActiveItemKeyChange={(k) => setOpenList(!!k)}>
        <CAccordionItem itemKey={1}>
          <CAccordionHeader>
            <strong>Game Guests List</strong>
          </CAccordionHeader>
          <CAccordionBody>
            <MemberCodeListing
              users={users}
              columns={columns}
              itemsPerPage={itemsPerPage}
              loading={loading}
              activePage={activePage}
              columnFilter={columnFilter}
              columnSorter={columnSorter}
              setActivePage={setActivePage}
              setItemsPerPage={setItemsPerPage}
              setColumnSorter={setColumnSorter}
              setColumnFilter={setColumnFilter}
              fetchData={fetchData}
              setLoading={setLoading}
            />
          </CAccordionBody>
        </CAccordionItem>
      </CAccordion>
    </CRow>
  )
}

export default MemberCode
